import React from "react";
import Logo from "../../assets/icons/logo.png";
import { useSelector } from "react-redux";

const FooterBar = () => {
  const { currentLanguageTitles } = useSelector((state) => state.languageReducer.data);
  return (
    <footer className="flex flex-col gap-10 justify-center items-center w-full p-10 mt-20">
      <img className="w-20 bg-black object-contain" src={Logo} alt="" />
      <p className="text-xs md:text-sm text-white text-opacity-50 font-semibold">
        {currentLanguageTitles?.[0]?.home_meta?.footer_copyright ??
          "Copyright @ Today with God 2024. | Privacy & Policy"}
      </p>
    </footer>
  );
};

export default FooterBar;
